// Weicher Hinweis im Erstell-Flow, wenn alle Stellen des Pakets belegt sind.
// Er blockiert nichts, Entwürfe gehen immer. Gesperrt wird erst beim
// Aktivieren über useLimitGuards. Nur in enforced und erst, wenn gezählt ist,
// Bestandskunden und preview sehen nichts.
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { MODES } from '../../features/pricing/entitlements'
import { useEntitlements, useLimit } from '../../features/pricing/hooks'
import {
  LIMIT_DIALOG_ACTIONS,
  usePricingDialog
} from '../../features/pricing/pricing-dialog-context'
import InfoCallout from '../tailwind/InfoCallout'

/**
 * Ob der Hinweis erscheint, rein und ohne React. Ersetzt die Stelle beim
 * Aktivieren eine aktive mit derselben external_custom_id, kostet das keinen
 * Platz, dann bleibt er weg.
 *
 * @param {{ mode: string, usage: object, replacesActiveCareer?: boolean }} params
 *   usage ist das Ergebnis von useLimit('careers')
 * @returns {boolean}
 */
export const showCareerLimitHint = ({
  mode,
  usage,
  replacesActiveCareer = false
}) =>
  mode === MODES.ENFORCED &&
  !!usage?.enforced &&
  usage.status === 'success' &&
  !replacesActiveCareer &&
  typeof usage.canAdd === 'function' &&
  !usage.canAdd(1)

const ACTION_CLASS =
  'inline-flex items-center whitespace-nowrap rounded font-semibold text-yellow-800 underline-offset-2 hover:text-yellow-900 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-700'

const CareerLimitHint = ({ replacesActiveCareer, source, className }) => {
  const { t } = useTranslation()
  const { mode } = useEntitlements()
  const usage = useLimit('careers')
  const dialog = usePricingDialog()

  if (!showCareerLimitHint({ mode, usage, replacesActiveCareer })) return null

  // Seite, kein Modal, der Limit-Dialog darf hier also direkt öffnen
  return (
    <InfoCallout
      tone='warning'
      className={className}
      action={
        <button
          type='button'
          aria-haspopup='dialog'
          onClick={() =>
            dialog?.openLimitDialog?.('careers', {
              source,
              action: LIMIT_DIALOG_ACTIONS.INFO
            })
          }
          className={ACTION_CLASS}
        >
          {t('pricing.banner.details_action')}
        </button>
      }
    >
      {t('pricing.limit.careers.draft_hint')}
    </InfoCallout>
  )
}

CareerLimitHint.propTypes = {
  replacesActiveCareer: PropTypes.bool,
  source: PropTypes.string,
  className: PropTypes.string
}

CareerLimitHint.defaultProps = {
  replacesActiveCareer: false,
  source: undefined,
  className: undefined
}

export default CareerLimitHint
